import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {ImageCroppedEvent} from 'ngx-image-cropper';
import {WebcamImage} from 'ngx-webcam';

@Component({
  selector: 'app-image-dialog-processing',
  templateUrl: './image-dialog-processing.component.html',
  styleUrls: ['./image-dialog-processing.component.scss']
})
export class ImageDialogProcessingComponent implements OnInit {

  direction: string;
  imageChangedEvent = null;
  croppedImage: any = null;
  isLoaded = false;
  imageBase64 = null;
  compress = true;
  public webcamImage: WebcamImage = null;

  constructor(@Inject(MAT_DIALOG_DATA) public data, private dialogRef: MatDialogRef<ImageDialogProcessingComponent>) {
  }

  ngOnInit(): void {
    const lang = localStorage.getItem('LANG');
    console.log(lang)
   // this.direction = lang === 'ar' ? 'rtl' : 'ltr';
    if (this.data) {
      this.isLoaded = true;
      this.fileChangeEvent(this.data.event);
    }
  }

  saveOnly(): void {
    if (this.webcamImage) {
      this.dialogRef.close({img: this.webcamImage.imageAsDataUrl, compress: this.compress});
    } else if (this.imageChangedEvent && this.imageChangedEvent.target && this.imageChangedEvent.target.files) {
      // Return the original file when no cropping is done
      this.dialogRef.close({compress: this.compress});
    } else {
      this.dialogRef.close({compress: this.compress});
    }
  }

  close() {
    this.dialogRef.close();
  }

  cropAndSave() {
    this.dialogRef.close({img: this.croppedImage, compress: this.compress});
  }

  fileChangeEvent(event): void {
    this.imageChangedEvent = event;
  }

  imageCropped(event: ImageCroppedEvent) {
    this.croppedImage = event.base64;
  }

  imageLoaded() {
    //
  }

  cropperReady() {
    //
  }

  loadImageFailed() {
    //
  }

  CheckCompressImage(event) {
    if (event.checked) {
      this.compress = true;
    } else {
      this.compress = false;
    }
  }

  handleImage(webcamImage: WebcamImage) {
    this.webcamImage = webcamImage;
    if (this.webcamImage) {
      this.imageBase64 = this.webcamImage.imageAsDataUrl;
    }
  }
}
